import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { motion } from 'framer-motion';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      setIsSubscribed(true);
      setEmail('');
      // In a real app, send to API here
    }
  };

  return (
    <footer className="bg-[#2C2C2C] text-[#F9F8F6] pt-24 pb-12 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-20">
          
          {/* Brand & Newsletter */}
          <div className="lg:col-span-2">
            <h3 className="font-serif text-3xl mb-6 tracking-widest">COZYNEST</h3>
            <p className="text-[#A3A3A3] max-w-sm mb-8 leading-relaxed">
              Join our mailing list to receive interior styling tips, early access to new collections, and a 10% discount on your first order.
            </p>
            
            {isSubscribed ? (
              <motion.div 
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                className="flex items-center gap-3 text-sm text-[#F9F8F6] bg-white/10 p-4 max-w-sm rounded-sm"
              >
                <SafeIcon icon={FiIcons.FiCheckCircle} className="w-5 h-5 text-[#8B7355]" />
                Thank you for subscribing! Check your inbox soon.
              </motion.div>
            ) : (
              <form onSubmit={handleSubscribe} className="flex border-b border-[#595959] max-w-sm focus-within:border-white transition-colors relative">
                <label htmlFor="newsletter-email" className="sr-only">Email address</label>
                <input 
                  id="newsletter-email"
                  type="email" 
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Email address" 
                  required
                  className="bg-transparent w-full py-3 outline-none text-[#F9F8F6] placeholder:text-[#737373]"
                />
                <button 
                  type="submit" 
                  className="text-sm tracking-widest uppercase hover:text-[#A3A3A3] px-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-sm my-1"
                >
                  Subscribe
                </button>
              </form>
            )}
          </div>

          {/* Links 1 */}
          <div>
            <h4 className="text-sm tracking-widest uppercase mb-6 text-[#A3A3A3]">Shop</h4>
            <ul className="space-y-4">
              <li><a href="#" className="hover:text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-sm px-1 -ml-1">All Products</a></li>
              <li><a href="#" className="hover:text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-sm px-1 -ml-1">Shop by Room</a></li>
              <li><a href="#" className="hover:text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-sm px-1 -ml-1">Bundles & Sets</a></li>
              <li><a href="#" className="hover:text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-sm px-1 -ml-1">Gift Cards</a></li>
            </ul>
          </div>

          {/* Links 2 */}
          <div>
            <h4 className="text-sm tracking-widest uppercase mb-6 text-[#A3A3A3]">Support</h4>
            <ul className="space-y-4">
              <li><a href="#" className="hover:text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-sm px-1 -ml-1">FAQ</a></li>
              <li><a href="#" className="hover:text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-sm px-1 -ml-1">Shipping & Returns</a></li>
              <li><a href="#" className="hover:text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-sm px-1 -ml-1">Contact Us</a></li>
              <li><a href="#" className="hover:text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-sm px-1 -ml-1">Trade Program</a></li>
            </ul>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#3D3D3D] pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-[#737373]">
          <p>&copy; {new Date().getFullYear()} CozyNest Home. All rights reserved.</p>
          <p className="mt-4 md:mt-0" style={{ textTransform: 'none' }}>
            <span>Made by </span><a href="https://diglab.ai/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-sm" style={{ textTransform: 'none' }}>DigLab.ai</a><span> and </span><a href="https://linglinkai.cn/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-sm" style={{ textTransform: 'none' }}>LingLinkAI.cn</a>
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="#" className="hover:text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-sm px-1" aria-label="Instagram">Instagram</a>
            <a href="#" className="hover:text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-sm px-1" aria-label="Pinterest">Pinterest</a>
            <a href="#" className="hover:text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-sm px-1" aria-label="Journal">Journal</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;